// ═══════════════════════════════════════════════════════════════════════════
// PAGE #search — Recherche d'action en pleine page (fallback responsive / étroit).
// Sur desktop l'entrée principale est l'overlay Spotlight (component-spotlight,
// loupe du header). Cette page réutilise la MÊME UI partagée (mountSearchUI).
// ═══════════════════════════════════════════════════════════════════════════

import { definePage } from '../router.js';
import { mountSearchUI } from './search-ui.js';

pages.search = definePage<'search'>(async () => {
  setHeader(t('pageSearch.title'), '');
  setContent('<div class="search-page" style="max-width:820px;margin:0 auto;"></div>');
  const root = document.querySelector<HTMLElement>('.search-page');
  if (root) mountSearchUI(root, { autofocus: true });
});

export {};
